import React, { useEffect } from "react";
import { connect } from 'react-redux';
import Select from "react-select";
import Tooltip from "@/tooltip";
import { Actions as DEPUTY_ACTIONS } from './store/deputyActions';
import { Actions as INTEGRATION_ACTIONS } from '../../../store/actions/integrationActions';

const DeputyEmployeeLink = ({
    thirdPartyList,
    getDeputyEmployees,
    createDeputyEmployee,
    thirdPartyId,
    disabled,
    agreementInfo,
    switchEmployeeLink
}) => {

    useEffect(() => {
        if (!thirdPartyList) getDeputyEmployees()
    }, [])

    return (
        <div className="col-xs-6 pl-0">
            <div className="col-xs-6 pr-0">
                <div className="form-material form-container">
                    <label htmlFor="material-text">
                        <Tooltip content="The employee reference code is used when importing punches or timesheets, hence it needs to be synchronised with third party software. If you do not link with third party software you are free to use this code for internal reference purposes.">
                            Deputy Link
                        </Tooltip>
                    </label>
                    <Select
                        isDisabled={disabled}
                        name="thirdPartyLink"
                        options={thirdPartyList}
                        value={thirdPartyList?.find(item => item.value == thirdPartyId)}
                        onChange={(selected) => {
                            switchEmployeeLink(selected.value)
                        }}
                    />
                </div>
            </div>
            {!thirdPartyId ?
                <div className="col-xs-6">
                    <div className="btn btn-success" type="submit" style={{ marginTop: 11 }}
                        onClick={() => {
                            createDeputyEmployee({
                                agreement: agreementInfo.id,
                                givenName: agreementInfo.employeeDetails.givenName,
                                familyName: agreementInfo.employeeDetails.familyName,
                                email: agreementInfo.employeeDetails.email,
                                dateOfBirth: agreementInfo.employeeDetails.dateOfBirth,
                            })
                        }}
                    >
                        Create In Deputy
                    </div>
                </div>
                : null}
        </div>
    )
}


const mapStateToProps = (state, ownProps) => {
    const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;

    const thirdPartyList = state.deputy?.employees?.map?.(e => ({
        label: e.fullName,
        value: e.deputyId,
    }))
    const thirdPartyId = state.employee?.deputyLink || state?.deputy?.links?.find?.(e => e?.agreement == agreementInfo?.id)?.deputy

    return {
        agreementInfo,
        thirdPartyList,
        thirdPartyId,
    }
}

const mapDispatchToProps = dispatch => ({
    isConnectedWithDeputy: () => dispatch(DEPUTY_ACTIONS.isConnectedWithDeputy()),
    linkDeputyEmployee: (input) => dispatch(DEPUTY_ACTIONS.linkDeputyEmployee(input)),
    createDeputyEmployee: (input) => dispatch(DEPUTY_ACTIONS.createDeputyEmployee(input)),
    getDeputyEmployees: () => dispatch(DEPUTY_ACTIONS.getDeputyEmployees()),
    switchEmployeeLink: (employee) => dispatch(INTEGRATION_ACTIONS.switchEmployeeLink(employee, 'deputy')),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeputyEmployeeLink)